module.exports = __webpack_public_path__ + "static/media/DDbanners2.a0614466.png";